export const matchingTranslations = {
  ru: {
    'matching.page.title': 'Сопоставления',
    'matching.page.subtitle': 'Связь банковских транзакций с контрагентами Syrve',
    'matching.tabs.aria': 'Раздел сопоставления',
    'matching.tabs.statements': 'Выписки',
    'matching.tabs.rules': 'Правила сопоставления',
    'matching.rules.subtabs.aria': 'Правила и исключения',
    'matching.rules.subtabs.rules': 'Правила',
    'matching.rules.subtabs.exclusions': 'Исключения',
    'matching.exclusions.subtitle': 'Операции, исключённые из сопоставления (зарплата, налоги, комиссии и т.п.). Их можно вернуть в очередь.',
    'matching.exclusions.rules.title': 'Правила автоисключения',
    'matching.exclusions.operations.title': 'Исключённые операции',
    'matching.exclusions.loading': 'Загружаем исключения…',
    'matching.exclusions.error': 'Не удалось загрузить исключения',
    'matching.exclusions.empty.title': 'Исключений пока нет',
    'matching.exclusions.empty.description': 'На вкладке «Сопоставление» нажмите «Исключить» у операции (например, payroll), чтобы она появилась здесь.',
    'matching.summary.autoMatched': 'Авто-сопоставлено',
    'matching.summary.lowConfidence': 'Низкая уверенность',
    'matching.summary.notFound': 'Не найдено',
    'matching.summary.manual': 'Вручную',
    'matching.filter.status': 'Сопоставление',
    'matching.filter.statusAria': 'Фильтр сопоставления',
    'matching.filter.import': 'Выписка',
    'matching.filter.importAria': 'Фильтр по банковской выписке',
    'matching.filter.importEmpty': 'Нет загруженных выписок',
    'matching.filter.allImports': 'Все выписки',
    'matching.import.reviewStatus.ok': 'Готово',
    'matching.import.reviewStatus.needsAttention': 'Проверить',
    'matching.import.reviewStatus.importIssue': 'Ошибка',
    'matching.import.optionReady': 'готово',
    'matching.import.optionNeedsReview': '{count} откр.',
    'matching.import.summaryHint':
      '{total}: нет {unmatched}, провер. {needsReview}',
    'matching.import.openStatement': 'Открыть',
    'matching.error.importSummaries': 'Не удалось загрузить список выписок',
    'matching.filter.all': 'Все',
    'matching.filter.unmatched': 'нет сопост.',
    'matching.filter.lowConfidence': 'проверить',
    'matching.filter.autoMatched': 'авто',
    'matching.filter.manualMatched': 'вручную',
    'matching.filter.excluded': 'исключено',
    'matching.error.summary': 'Не удалось загрузить сводку сопоставлений',
    'matching.error.list': 'Не удалось загрузить сопоставления',
    'matching.empty.title': 'Нет сопоставлений',
    'matching.empty.description': 'По выбранному фильтру нет банковских транзакций для проверки.',
    'matching.table.bankText': 'Название / описание из банка',
    'matching.table.syrveCounterparty': 'Контрагент Syrve',
    'matching.table.confidence': 'Увер.',
    'matching.table.matchStatus': 'Сопоставление',
    'matching.counterpartyUnrecognized': 'Не распознан',
    'matching.action.match': 'Сопоставить',
    'matching.action.review': 'Проверить',
    'matching.action.edit': 'Изменить',
    'matching.action.continue': 'Дальше',
    'matching.action.revert': 'Отменить',
    'matching.action.exclude': 'Исключить',
    'matching.action.unexclude': 'Вернуть',
    'matching.exclude.title': 'Исключить из сопоставления',
    'matching.exclude.hint':
      'Платежка не будет сопоставляться с поставщиком (например ЗП, налоги, комиссии). Её можно вернуть в очередь позже.',
    'matching.exclude.category': 'Причина',
    'matching.exclude.category.required': 'Выберите причину исключения.',
    'matching.exclude.category.Salary': 'Заработная плата',
    'matching.exclude.category.Tax': 'Налоги',
    'matching.exclude.category.BankFee': 'Банковская комиссия',
    'matching.exclude.category.InternalTransfer': 'Внутренний перевод',
    'matching.exclude.category.Other': 'Прочее',
    'matching.exclude.pattern': 'Ключ автоисключения',
    'matching.exclude.pattern.hint': 'Следующие операции с этим текстом будут исключаться автоматически. Оставьте только устойчивый признак.',
    'matching.exclude.pattern.required': 'Укажите ключ автоисключения.',
    'matching.exclude.comment': 'Комментарий (необязательно)',
    'matching.exclude.comment.placeholder': 'Краткое пояснение',
    'matching.exclude.submit': 'Исключить',
    'matching.exclude.cancel': 'Отмена',
    'matching.exclude.success': 'Платежка исключена из сопоставления.',
    'matching.exclude.successWithRule': 'Операция исключена, правило сохранено. Дополнительно исключено: {count}.',
    'matching.exclude.error': 'Не удалось исключить платежку',
    'matching.unexclude.confirm': 'Вернуть платежку в очередь сопоставления?',
    'matching.unexclude.success': 'Платежка возвращена в очередь сопоставления.',
    'matching.unexclude.error': 'Не удалось вернуть платежку в очередь',
    'matching.revert.confirm': 'Отменить ручное сопоставление? Транзакция вернётся в список для проверки.',
    'matching.revert.success': 'Ручное сопоставление отменено.',
    'matching.revert.error': 'Не удалось отменить сопоставление',
    'matching.rules.title': 'Правила сопоставления',
    'matching.rules.subtitle': 'Активные правила, которые применяются к будущим импортам и пересчитывают текущие сопоставления по приоритету',
    'matching.rules.catalogLink': 'Справочник правил',
    'matching.rules.loading': 'Загружаем правила сопоставления…',
    'matching.rules.error': 'Не удалось загрузить правила сопоставления',
    'matching.rules.empty.title': 'Правил пока нет',
    'matching.rules.empty.description': 'Создайте правило из мастера сопоставления, чтобы следующие импорты сопоставлялись автоматически.',
    'matching.rules.table.bankName': 'Банковское имя',
    'matching.rules.table.priority': 'Приоритет',
    'matching.rules.active': 'Активно',
    'matching.rules.inactive': 'Отключено',
    'matching.rules.catalog.title': 'Правила сопоставления',
    'matching.rules.catalog.subtitle': 'Справочник правил распознавания контрагентов для импорта банковских выписок',
    'matching.rules.catalog.subtitleManage': 'Управление active/inactive правилами распознавания контрагентов. Conflict preview доступен только в мастере сопоставления.',
    'matching.rules.catalog.backToMatching': 'К сопоставлениям',
    'matching.rules.catalog.filter.status': 'Статус',
    'matching.rules.catalog.filter.aria': 'Фильтр активности правил',
    'matching.rules.catalog.filter.activeOnly': 'Только активные',
    'matching.rules.catalog.filter.all': 'Все правила',
    'matching.rules.catalog.loadingRules': 'Загружаем правила…',
    'matching.rules.catalog.emptyCatalog': 'Создайте правило из мастера сопоставления на странице «Сопоставления».',
    'matching.rules.catalog.table.syrveCounterparty': 'Syrve контрагент',
    'matching.rules.catalog.table.scope': 'Область',
    'matching.rules.catalog.table.actions': 'Действия',
    'matching.rules.catalog.scope.location': 'Точка',
    'matching.rules.catalog.scope.parentOrg': 'Родительская организация',
    'matching.rules.catalog.scope.organization': 'Организация',
    'matching.rules.catalog.action.deactivate': 'Отключить',
    'matching.rules.catalog.action.activate': 'Включить',
    'matching.rules.catalog.readOnly': 'Только просмотр',
    'matching.rules.catalog.contextEmpty.title': 'Контекст не выбран',
    'matching.rules.catalog.contextEmpty.description': 'Выберите организацию и точку, чтобы просмотреть правила сопоставления.',
    'matching.rules.edit.title': 'Редактирование правила',
    'matching.rules.edit.bankName': 'Банковское имя',
    'matching.rules.edit.normalized': 'Нормализовано: {value}',
    'matching.rules.edit.syrveCounterparty': 'Syrve контрагент',
    'matching.rules.edit.loadingCounterparties': 'Загружаем контрагентов…',
    'matching.rules.edit.counterpartiesError': 'Не удалось загрузить контрагентов',
    'matching.rules.edit.selectCounterparty': 'Выберите контрагента',
    'matching.rules.edit.priority': 'Приоритет',
    'matching.rules.edit.save': 'Сохранить',
    'matching.rules.error.invalidPriority': 'Укажите корректный приоритет.',
    'matching.rules.error.counterpartyRequired': 'Выберите контрагента Syrve.',
    'matching.rules.error.saveFailed': 'Не удалось сохранить правило.',
    'matching.rules.error.deactivateFailed': 'Не удалось деактивировать правило.',
    'matching.rules.error.activateFailed': 'Не удалось активировать правило.',
    'matching.signal.rule': 'Правило',
    'matching.signal.normalizedRule': 'Нормализованное правило',
    'matching.signal.normalizedBankName': 'Нормализованное имя банка',
    'matching.signal.priority': 'Приоритет',
    'matching.signal.exactMatch': 'Точное совпадение',
    'matching.signal.normalizedMatch': 'Совпадение после нормализации',
    'matching.signal.containsMatch': 'Частичное вхождение',
    'matching.signal.manualSelection': 'Выбор оператора',
    'matching.status.unmatched': 'нет сопост.',
    'matching.status.lowConfidence': 'проверить',
    'matching.status.autoMatched': 'авто',
    'matching.status.manualMatched': 'вручную',
    'matching.status.excluded': 'исключено',
    'matching.matchType.rule': 'Правило',
    'matching.matchType.normalized': 'Нормализация',
    'matching.matchType.candidate': 'Кандидат',
    'matching.matchType.manual': 'Вручную',
    'matching.matchType.unmatched': 'Без совпадения',
    'matching.matchType.excluded': 'Исключено',
    'matching.signal.excludeCategory': 'Причина исключения',
    'matching.signal.excludeComment': 'Комментарий',
    'matching.wizard.title': 'Мастер сопоставления контрагента',
    'matching.wizard.title.complete': 'Сопоставление завершено',
    'matching.wizard.step.transaction': 'Транзакция',
    'matching.wizard.step.counterparty': 'Контрагент',
    'matching.wizard.step.rule': 'Правило',
    'matching.wizard.step.done': 'Готово',
    'matching.wizard.review.nextSteps.title': 'Что делать дальше',
    'matching.wizard.review.nextSteps.1': 'Проверьте данные банковской транзакции.',
    'matching.wizard.review.nextSteps.2': 'Нажмите «Выбрать контрагента Syrve» и укажите поставщика в справочнике.',
    'matching.wizard.review.nextSteps.3': 'При необходимости создайте правило — похожие платежи будут сопоставляться автоматически.',
    'matching.wizard.review.transactionTitle': 'Банковская транзакция',
    'matching.wizard.review.counterpartyFromBank': 'Контрагент из банка',
    'matching.wizard.review.currentStatus': 'Текущий статус',
    'matching.wizard.review.selectCounterparty': 'Выбрать контрагента Syrve',
    'matching.wizard.select.title': 'Выбор контрагента Syrve',
    'matching.wizard.select.counterpartyLabel': 'Контрагент Syrve',
    'matching.wizard.select.kindLabel': 'Тип контрагента',
    'matching.wizard.select.kindPlaceholder': 'Выберите тип',
    'matching.wizard.select.pickKindFirst': 'Сначала выберите тип — список покажет только активных контрагентов этого типа.',
    'matching.wizard.select.noActiveForKind': 'Нет активных (неудалённых) контрагентов этого типа.',
    'matching.wizard.select.placeholder': 'Название, ID или ИНН',
    'matching.wizard.select.emptySearch': 'Контрагенты не найдены. Измените строку поиска.',
    'matching.wizard.select.loading': 'Загружаем контрагентов Syrve…',
    'matching.wizard.select.error': 'Не удалось загрузить контрагентов Syrve',
    'matching.wizard.select.confirm': 'Подтвердить сопоставление',
    'matching.wizard.select.sync.empty.title': 'Контрагенты не найдены',
    'matching.wizard.select.sync.empty.description': 'Справочник контрагентов пуст. Синхронизируйте поставщиков из Syrve и повторите попытку.',
    'matching.wizard.select.sync.button': 'Синхронизировать контрагентов',
    'matching.wizard.select.sync.connectionsLink': 'Подключения Syrve',
    'matching.wizard.select.sync.noConnection': 'Сначала настройте подключение Syrve.',
    'matching.wizard.select.sync.error': 'Не удалось синхронизировать контрагентов Syrve.',
    'matching.wizard.select.matchError': 'Не удалось сохранить ручное сопоставление',
    'matching.wizard.rule.title': 'Правило для будущих импортов',
    'matching.wizard.rule.saved': 'Ручное сопоставление сохранено.',
    'matching.wizard.rule.hint': 'Укажите текст, по которому в следующих выписках найдём этого контрагента. Можно укоротить до устойчивого фрагмента имени.',
    'matching.wizard.rule.bankName': 'Признак для автосопоставления',
    'matching.wizard.rule.normalizedName': 'Нормализованное имя',
    'matching.wizard.rule.priority': 'Приоритет',
    'matching.wizard.rule.priorityPlaceholder': 'Backend назначит автоматически',
    'matching.wizard.rule.emptyPattern': 'Паттерн после нормализации пуст — правило создать нельзя. Завершите без правила.',
    'matching.wizard.rule.skip': 'Завершить без правила',
    'matching.wizard.rule.create': 'Создать правило',
    'matching.wizard.rule.conflicts.title': 'Предпросмотр конфликтов',
    'matching.wizard.rule.conflicts.hint': 'Эффективный приоритет: {priority}. Проверьте предупреждения перед сохранением.',
    'matching.wizard.rule.conflicts.loading': 'Проверяем конфликты правил…',
    'matching.wizard.rule.conflicts.error': 'Не удалось проверить конфликты правила',
    'matching.wizard.rule.createError': 'Не удалось создать правило сопоставления',
    'matching.wizard.conflict.exactDuplicate': 'Точный дубликат',
    'matching.wizard.conflict.duplicateScope': 'Конфликт сопоставления',
    'matching.wizard.conflict.overlapping': 'Пересечение паттернов',
    'matching.wizard.conflict.priorityShadowing': 'Приоритет',
    'matching.wizard.conflict.differentMapping': 'Другой контрагент Syrve',
    'matching.wizard.conflict.default': 'Конфликт',
    'matching.wizard.conflict.ruleLine': 'Правило: {pattern} → {counterparty} (priority {priority})',
    'matching.wizard.complete.done': 'Готово',
    'matching.wizard.complete.skipped': 'Правило не создано.',
    'matching.wizard.complete.manualSaved': 'Ручное сопоставление сохранено.',
    'matching.wizard.complete.withRule': 'Ручное сопоставление сохранено. {message}',
    'matching.wizard.complete.skippedFull': 'Ручное сопоставление сохранено. Правило не создано.',
    'matching.wizard.rule.created': 'Правило создано. Следующие импорты будут сопоставляться автоматически.',
    'matching.wizard.rule.createdReapplied': 'Правило создано. Обновлено сопоставлений: {count}.',
    'matching.wizard.rule.alreadyExists': 'Такое правило уже существует. Повторное правило не создано.',
    'matching.wizard.rule.alreadyExistsReapplied': 'Такое правило уже существует. Обновлено сопоставлений: {count}.',
    'matching.wizard.sync.success': 'Синхронизация завершена: найдено {seen}, добавлено {inserted}, обновлено {updated}.',
  },
  en: {
    'matching.page.title': 'Matching',
    'matching.page.subtitle': 'Link bank transactions to Syrve counterparties',
    'matching.tabs.aria': 'Matching section',
    'matching.tabs.statements': 'Statements',
    'matching.tabs.rules': 'Matching rules',
    'matching.rules.subtabs.aria': 'Rules and exclusions',
    'matching.rules.subtabs.rules': 'Rules',
    'matching.rules.subtabs.exclusions': 'Exclusions',
    'matching.exclusions.subtitle': 'Operations excluded from matching (salary, taxes, fees, etc.). You can restore them to the queue.',
    'matching.exclusions.rules.title': 'Auto-exclusion rules',
    'matching.exclusions.operations.title': 'Excluded operations',
    'matching.exclusions.loading': 'Loading exclusions…',
    'matching.exclusions.error': 'Failed to load exclusions',
    'matching.exclusions.empty.title': 'No exclusions yet',
    'matching.exclusions.empty.description': 'On the Matching tab, click Exclude on an operation (e.g. payroll) to list it here.',
    'matching.summary.autoMatched': 'Auto-matched',
    'matching.summary.lowConfidence': 'Low confidence',
    'matching.summary.notFound': 'Not found',
    'matching.summary.manual': 'Manual',
    'matching.filter.status': 'Matching',
    'matching.filter.statusAria': 'Matching filter',
    'matching.filter.import': 'Statement',
    'matching.filter.importAria': 'Bank statement filter',
    'matching.filter.importEmpty': 'No imported statements',
    'matching.filter.allImports': 'All statements',
    'matching.import.reviewStatus.ok': 'Ready',
    'matching.import.reviewStatus.needsAttention': 'Review',
    'matching.import.reviewStatus.importIssue': 'Error',
    'matching.import.optionReady': 'ready',
    'matching.import.optionNeedsReview': '{count} open',
    'matching.import.summaryHint':
      '{total}: none {unmatched}, review {needsReview}',
    'matching.import.openStatement': 'Open',
    'matching.error.importSummaries': 'Failed to load statement list',
    'matching.filter.all': 'All',
    'matching.filter.unmatched': 'no match',
    'matching.filter.lowConfidence': 'review',
    'matching.filter.autoMatched': 'auto',
    'matching.filter.manualMatched': 'manual',
    'matching.filter.excluded': 'excluded',
    'matching.error.summary': 'Failed to load matching summary',
    'matching.error.list': 'Failed to load matches',
    'matching.empty.title': 'No matches',
    'matching.empty.description': 'No bank transactions match the selected filter.',
    'matching.table.bankText': 'Bank name / description',
    'matching.table.syrveCounterparty': 'Syrve counterparty',
    'matching.table.confidence': 'Conf.',
    'matching.table.matchStatus': 'Matching',
    'matching.counterpartyUnrecognized': 'Unrecognized',
    'matching.action.match': 'Match',
    'matching.action.review': 'Review',
    'matching.action.edit': 'Edit',
    'matching.action.continue': 'Continue',
    'matching.action.revert': 'Undo',
    'matching.action.exclude': 'Exclude',
    'matching.action.unexclude': 'Restore',
    'matching.exclude.title': 'Exclude from matching',
    'matching.exclude.hint':
      'This payment will not be matched to a supplier (e.g. salary, taxes, fees). You can restore it to the queue later.',
    'matching.exclude.category': 'Reason',
    'matching.exclude.category.required': 'Select an exclusion reason.',
    'matching.exclude.category.Salary': 'Salary',
    'matching.exclude.category.Tax': 'Taxes',
    'matching.exclude.category.BankFee': 'Bank fee',
    'matching.exclude.category.InternalTransfer': 'Internal transfer',
    'matching.exclude.category.Other': 'Other',
    'matching.exclude.pattern': 'Auto-exclusion key',
    'matching.exclude.pattern.hint': 'Future operations containing this text will be excluded automatically. Keep only a stable marker.',
    'matching.exclude.pattern.required': 'Enter an auto-exclusion key.',
    'matching.exclude.comment': 'Comment (optional)',
    'matching.exclude.comment.placeholder': 'Short note',
    'matching.exclude.submit': 'Exclude',
    'matching.exclude.cancel': 'Cancel',
    'matching.exclude.success': 'Payment excluded from matching.',
    'matching.exclude.successWithRule': 'Operation excluded and rule saved. Additional exclusions: {count}.',
    'matching.exclude.error': 'Failed to exclude payment',
    'matching.unexclude.confirm': 'Restore this payment to the matching queue?',
    'matching.unexclude.success': 'Payment restored to the matching queue.',
    'matching.unexclude.error': 'Failed to restore payment to the queue',
    'matching.revert.confirm': 'Revert manual matching? The transaction will return to the review list.',
    'matching.revert.success': 'Manual matching reverted.',
    'matching.revert.error': 'Failed to revert matching',
    'matching.rules.title': 'Matching rules',
    'matching.rules.subtitle': 'Active rules applied to future imports by priority',
    'matching.rules.catalogLink': 'Rules catalog',
    'matching.rules.loading': 'Loading matching rules…',
    'matching.rules.error': 'Failed to load matching rules',
    'matching.rules.empty.title': 'No rules yet',
    'matching.rules.empty.description': 'Create a rule from the matching wizard to auto-match future imports.',
    'matching.rules.table.bankName': 'Bank name',
    'matching.rules.table.priority': 'Priority',
    'matching.rules.active': 'Active',
    'matching.rules.inactive': 'Disabled',
    'matching.rules.catalog.title': 'Matching rules',
    'matching.rules.catalog.subtitle': 'Counterparty recognition rules catalog for bank statement imports',
    'matching.rules.catalog.subtitleManage': 'Manage active/inactive counterparty recognition rules. Conflict preview is only available in the matching wizard.',
    'matching.rules.catalog.backToMatching': 'Back to matching',
    'matching.rules.catalog.filter.status': 'Status',
    'matching.rules.catalog.filter.aria': 'Rule activity filter',
    'matching.rules.catalog.filter.activeOnly': 'Active only',
    'matching.rules.catalog.filter.all': 'All rules',
    'matching.rules.catalog.loadingRules': 'Loading rules…',
    'matching.rules.catalog.emptyCatalog': 'Create a rule from the matching wizard on the Matching page.',
    'matching.rules.catalog.table.syrveCounterparty': 'Syrve counterparty',
    'matching.rules.catalog.table.scope': 'Scope',
    'matching.rules.catalog.table.actions': 'Actions',
    'matching.rules.catalog.scope.location': 'Location',
    'matching.rules.catalog.scope.parentOrg': 'Parent organization',
    'matching.rules.catalog.scope.organization': 'Organization',
    'matching.rules.catalog.action.deactivate': 'Deactivate',
    'matching.rules.catalog.action.activate': 'Activate',
    'matching.rules.catalog.readOnly': 'View only',
    'matching.rules.catalog.contextEmpty.title': 'Context not selected',
    'matching.rules.catalog.contextEmpty.description': 'Select an organization and location to view matching rules.',
    'matching.rules.edit.title': 'Edit rule',
    'matching.rules.edit.bankName': 'Bank name',
    'matching.rules.edit.normalized': 'Normalized: {value}',
    'matching.rules.edit.syrveCounterparty': 'Syrve counterparty',
    'matching.rules.edit.loadingCounterparties': 'Loading counterparties…',
    'matching.rules.edit.counterpartiesError': 'Failed to load counterparties',
    'matching.rules.edit.selectCounterparty': 'Select counterparty',
    'matching.rules.edit.priority': 'Priority',
    'matching.rules.edit.save': 'Save',
    'matching.rules.error.invalidPriority': 'Enter a valid priority.',
    'matching.rules.error.counterpartyRequired': 'Select a Syrve counterparty.',
    'matching.rules.error.saveFailed': 'Failed to save rule.',
    'matching.rules.error.deactivateFailed': 'Failed to deactivate rule.',
    'matching.rules.error.activateFailed': 'Failed to activate rule.',
    'matching.signal.rule': 'Rule',
    'matching.signal.normalizedRule': 'Normalized rule',
    'matching.signal.normalizedBankName': 'Normalized bank name',
    'matching.signal.priority': 'Priority',
    'matching.signal.exactMatch': 'Exact match',
    'matching.signal.normalizedMatch': 'Normalized match',
    'matching.signal.containsMatch': 'Partial match',
    'matching.signal.manualSelection': 'Operator selection',
    'matching.status.unmatched': 'no match',
    'matching.status.lowConfidence': 'review',
    'matching.status.autoMatched': 'auto',
    'matching.status.manualMatched': 'manual',
    'matching.status.excluded': 'excluded',
    'matching.matchType.rule': 'Rule',
    'matching.matchType.normalized': 'Normalization',
    'matching.matchType.candidate': 'Candidate',
    'matching.matchType.manual': 'Manual',
    'matching.matchType.unmatched': 'No match',
    'matching.matchType.excluded': 'Excluded',
    'matching.signal.excludeCategory': 'Exclusion reason',
    'matching.signal.excludeComment': 'Comment',
    'matching.wizard.title': 'Counterparty matching wizard',
    'matching.wizard.title.complete': 'Matching completed',
    'matching.wizard.step.transaction': 'Transaction',
    'matching.wizard.step.counterparty': 'Counterparty',
    'matching.wizard.step.rule': 'Rule',
    'matching.wizard.step.done': 'Done',
    'matching.wizard.review.nextSteps.title': 'What to do next',
    'matching.wizard.review.nextSteps.1': 'Review the bank transaction details.',
    'matching.wizard.review.nextSteps.2': 'Click “Select Syrve counterparty” and choose a supplier from the catalog.',
    'matching.wizard.review.nextSteps.3': 'Optionally create a rule so similar payments are matched automatically.',
    'matching.wizard.review.transactionTitle': 'Bank transaction',
    'matching.wizard.review.counterpartyFromBank': 'Counterparty from bank',
    'matching.wizard.review.currentStatus': 'Current status',
    'matching.wizard.review.selectCounterparty': 'Select Syrve counterparty',
    'matching.wizard.select.title': 'Select Syrve counterparty',
    'matching.wizard.select.counterpartyLabel': 'Syrve counterparty',
    'matching.wizard.select.kindLabel': 'Counterparty type',
    'matching.wizard.select.kindPlaceholder': 'Select a type',
    'matching.wizard.select.pickKindFirst': 'Select a type first — the list shows only active counterparties of that type.',
    'matching.wizard.select.noActiveForKind': 'No active (non-deleted) counterparties for this type.',
    'matching.wizard.select.placeholder': 'Name, ID, or tax ID',
    'matching.wizard.select.emptySearch': 'No counterparties found. Change your search.',
    'matching.wizard.select.loading': 'Loading Syrve counterparties…',
    'matching.wizard.select.error': 'Failed to load Syrve counterparties',
    'matching.wizard.select.confirm': 'Confirm matching',
    'matching.wizard.select.sync.empty.title': 'No counterparties found',
    'matching.wizard.select.sync.empty.description': 'The counterparty catalog is empty. Sync suppliers from Syrve and try again.',
    'matching.wizard.select.sync.button': 'Sync counterparties',
    'matching.wizard.select.sync.connectionsLink': 'Syrve connections',
    'matching.wizard.select.sync.noConnection': 'Configure a Syrve connection first.',
    'matching.wizard.select.sync.error': 'Failed to sync Syrve counterparties.',
    'matching.wizard.select.matchError': 'Failed to save manual matching',
    'matching.wizard.rule.title': 'Rule for future imports',
    'matching.wizard.rule.saved': 'Manual matching saved.',
    'matching.wizard.rule.hint': 'Enter the text used to find this counterparty in future statements. You can shorten it to a stable name fragment.',
    'matching.wizard.rule.bankName': 'Auto-match pattern',
    'matching.wizard.rule.normalizedName': 'Normalized name',
    'matching.wizard.rule.priority': 'Priority',
    'matching.wizard.rule.priorityPlaceholder': 'Assigned automatically by backend',
    'matching.wizard.rule.emptyPattern': 'Normalized pattern is empty — cannot create a rule. Finish without a rule.',
    'matching.wizard.rule.skip': 'Finish without rule',
    'matching.wizard.rule.create': 'Create rule',
    'matching.wizard.rule.conflicts.title': 'Conflict preview',
    'matching.wizard.rule.conflicts.hint': 'Effective priority: {priority}. Review warnings before saving.',
    'matching.wizard.rule.conflicts.loading': 'Checking rule conflicts…',
    'matching.wizard.rule.conflicts.error': 'Failed to check rule conflicts',
    'matching.wizard.rule.createError': 'Failed to create matching rule',
    'matching.wizard.conflict.exactDuplicate': 'Exact duplicate',
    'matching.wizard.conflict.duplicateScope': 'Mapping conflict',
    'matching.wizard.conflict.overlapping': 'Overlapping patterns',
    'matching.wizard.conflict.priorityShadowing': 'Priority',
    'matching.wizard.conflict.differentMapping': 'Different Syrve counterparty',
    'matching.wizard.conflict.default': 'Conflict',
    'matching.wizard.conflict.ruleLine': 'Rule: {pattern} → {counterparty} (priority {priority})',
    'matching.wizard.complete.done': 'Done',
    'matching.wizard.complete.skipped': 'Rule was not created.',
    'matching.wizard.complete.manualSaved': 'Manual matching saved.',
    'matching.wizard.complete.withRule': 'Manual matching saved. {message}',
    'matching.wizard.complete.skippedFull': 'Manual matching saved. Rule was not created.',
    'matching.wizard.rule.created': 'Rule created. Future imports will match automatically.',
    'matching.wizard.rule.createdReapplied': 'Rule created. Updated matches: {count}.',
    'matching.wizard.rule.alreadyExists': 'This rule already exists. Duplicate rule was not created.',
    'matching.wizard.rule.alreadyExistsReapplied': 'This rule already exists. Updated matches: {count}.',
    'matching.wizard.sync.success': 'Sync completed: found {seen}, inserted {inserted}, updated {updated}.',
  },
  id: {
    'matching.page.title': 'Pencocokan',
    'matching.page.subtitle': 'Menghubungkan transaksi bank dengan counterparty Syrve',
    'matching.tabs.aria': 'Bagian pencocokan',
    'matching.tabs.statements': 'Rekening koran',
    'matching.tabs.rules': 'Aturan pencocokan',
    'matching.rules.subtabs.aria': 'Aturan dan pengecualian',
    'matching.rules.subtabs.rules': 'Aturan',
    'matching.rules.subtabs.exclusions': 'Pengecualian',
    'matching.exclusions.subtitle': 'Operasi yang dikecualikan dari pencocokan (gaji, pajak, biaya, dll.). Anda dapat mengembalikannya ke antrean.',
    'matching.exclusions.rules.title': 'Aturan pengecualian otomatis',
    'matching.exclusions.operations.title': 'Operasi yang dikecualikan',
    'matching.exclusions.loading': 'Memuat pengecualian…',
    'matching.exclusions.error': 'Gagal memuat pengecualian',
    'matching.exclusions.empty.title': 'Belum ada pengecualian',
    'matching.exclusions.empty.description': 'Di tab Pencocokan, klik Kecualikan pada operasi (mis. payroll) agar muncul di sini.',
    'matching.summary.autoMatched': 'Cocok otomatis',
    'matching.summary.lowConfidence': 'Kepercayaan rendah',
    'matching.summary.notFound': 'Tidak ditemukan',
    'matching.summary.manual': 'Manual',
    'matching.filter.status': 'Pencocokan',
    'matching.filter.statusAria': 'Filter pencocokan',
    'matching.filter.import': 'Rekening koran',
    'matching.filter.importAria': 'Filter rekening koran',
    'matching.filter.importEmpty': 'Belum ada impor',
    'matching.filter.allImports': 'Semua rekening koran',
    'matching.import.reviewStatus.ok': 'Siap',
    'matching.import.reviewStatus.needsAttention': 'Periksa',
    'matching.import.reviewStatus.importIssue': 'Error',
    'matching.import.optionReady': 'siap',
    'matching.import.optionNeedsReview': '{count} terbuka',
    'matching.import.summaryHint':
      '{total}: tidak {unmatched}, periksa {needsReview}',
    'matching.import.openStatement': 'Buka',
    'matching.error.importSummaries': 'Gagal memuat daftar rekening koran',
    'matching.filter.all': 'Semua',
    'matching.filter.unmatched': 'tidak cocok',
    'matching.filter.lowConfidence': 'periksa',
    'matching.filter.autoMatched': 'otomatis',
    'matching.filter.manualMatched': 'manual',
    'matching.filter.excluded': 'dikecualikan',
    'matching.error.summary': 'Gagal memuat ringkasan pencocokan',
    'matching.error.list': 'Gagal memuat pencocokan',
    'matching.empty.title': 'Tidak ada pencocokan',
    'matching.empty.description': 'Tidak ada transaksi bank untuk filter yang dipilih.',
    'matching.table.bankText': 'Nama / deskripsi bank',
    'matching.table.syrveCounterparty': 'Counterparty Syrve',
    'matching.table.confidence': 'Yakin',
    'matching.table.matchStatus': 'Pencocokan',
    'matching.counterpartyUnrecognized': 'Tidak dikenali',
    'matching.action.match': 'Cocokkan',
    'matching.action.review': 'Periksa',
    'matching.action.edit': 'Ubah',
    'matching.action.continue': 'Lanjut',
    'matching.action.revert': 'Batalkan',
    'matching.action.exclude': 'Kecualikan',
    'matching.action.unexclude': 'Kembalikan',
    'matching.exclude.title': 'Kecualikan dari pencocokan',
    'matching.exclude.hint':
      'Pembayaran ini tidak akan dicocokkan dengan pemasok (mis. gaji, pajak, biaya). Anda dapat mengembalikannya ke antrean nanti.',
    'matching.exclude.category': 'Alasan',
    'matching.exclude.category.required': 'Pilih alasan pengecualian.',
    'matching.exclude.category.Salary': 'Gaji',
    'matching.exclude.category.Tax': 'Pajak',
    'matching.exclude.category.BankFee': 'Biaya bank',
    'matching.exclude.category.InternalTransfer': 'Transfer internal',
    'matching.exclude.category.Other': 'Lainnya',
    'matching.exclude.pattern': 'Kunci pengecualian otomatis',
    'matching.exclude.pattern.hint': 'Operasi berikutnya yang berisi teks ini akan dikecualikan otomatis. Sisakan penanda yang stabil.',
    'matching.exclude.pattern.required': 'Masukkan kunci pengecualian otomatis.',
    'matching.exclude.comment': 'Komentar (opsional)',
    'matching.exclude.comment.placeholder': 'Catatan singkat',
    'matching.exclude.submit': 'Kecualikan',
    'matching.exclude.cancel': 'Batal',
    'matching.exclude.success': 'Pembayaran dikecualikan dari pencocokan.',
    'matching.exclude.successWithRule': 'Operasi dikecualikan dan aturan disimpan. Pengecualian tambahan: {count}.',
    'matching.exclude.error': 'Gagal mengecualikan pembayaran',
    'matching.unexclude.confirm': 'Kembalikan pembayaran ke antrean pencocokan?',
    'matching.unexclude.success': 'Pembayaran dikembalikan ke antrean pencocokan.',
    'matching.unexclude.error': 'Gagal mengembalikan pembayaran ke antrean',
    'matching.revert.confirm': 'Batalkan pencocokan manual? Transaksi akan kembali ke daftar pemeriksaan.',
    'matching.revert.success': 'Pencocokan manual dibatalkan.',
    'matching.revert.error': 'Gagal membatalkan pencocokan',
    'matching.rules.title': 'Aturan pencocokan',
    'matching.rules.subtitle': 'Aturan aktif untuk impor berikutnya berdasarkan prioritas',
    'matching.rules.catalogLink': 'Katalog aturan',
    'matching.rules.loading': 'Memuat aturan pencocokan…',
    'matching.rules.error': 'Gagal memuat aturan pencocokan',
    'matching.rules.empty.title': 'Belum ada aturan',
    'matching.rules.empty.description': 'Buat aturan dari wizard pencocokan agar impor berikutnya cocok otomatis.',
    'matching.rules.table.bankName': 'Nama bank',
    'matching.rules.table.priority': 'Prioritas',
    'matching.rules.active': 'Aktif',
    'matching.rules.inactive': 'Nonaktif',
    'matching.rules.catalog.title': 'Aturan pencocokan',
    'matching.rules.catalog.subtitle': 'Katalog aturan pengenalan rekanan untuk impor rekening koran',
    'matching.rules.catalog.subtitleManage': 'Kelola aturan pengenalan rekanan aktif/nonaktif. Pratinjau konflik hanya tersedia di wizard pencocokan.',
    'matching.rules.catalog.backToMatching': 'Kembali ke pencocokan',
    'matching.rules.catalog.filter.status': 'Status',
    'matching.rules.catalog.filter.aria': 'Filter aktivitas aturan',
    'matching.rules.catalog.filter.activeOnly': 'Hanya aktif',
    'matching.rules.catalog.filter.all': 'Semua aturan',
    'matching.rules.catalog.loadingRules': 'Memuat aturan…',
    'matching.rules.catalog.emptyCatalog': 'Buat aturan dari wizard pencocokan di halaman Pencocokan.',
    'matching.rules.catalog.table.syrveCounterparty': 'Rekanan Syrve',
    'matching.rules.catalog.table.scope': 'Cakupan',
    'matching.rules.catalog.table.actions': 'Tindakan',
    'matching.rules.catalog.scope.location': 'Lokasi',
    'matching.rules.catalog.scope.parentOrg': 'Organisasi induk',
    'matching.rules.catalog.scope.organization': 'Organisasi',
    'matching.rules.catalog.action.deactivate': 'Nonaktifkan',
    'matching.rules.catalog.action.activate': 'Aktifkan',
    'matching.rules.catalog.readOnly': 'Hanya lihat',
    'matching.rules.catalog.contextEmpty.title': 'Konteks belum dipilih',
    'matching.rules.catalog.contextEmpty.description': 'Pilih organisasi dan lokasi untuk melihat aturan pencocokan.',
    'matching.rules.edit.title': 'Edit aturan',
    'matching.rules.edit.bankName': 'Nama bank',
    'matching.rules.edit.normalized': 'Ternormalisasi: {value}',
    'matching.rules.edit.syrveCounterparty': 'Rekanan Syrve',
    'matching.rules.edit.loadingCounterparties': 'Memuat rekanan…',
    'matching.rules.edit.counterpartiesError': 'Gagal memuat rekanan',
    'matching.rules.edit.selectCounterparty': 'Pilih rekanan',
    'matching.rules.edit.priority': 'Prioritas',
    'matching.rules.edit.save': 'Simpan',
    'matching.rules.error.invalidPriority': 'Masukkan prioritas yang valid.',
    'matching.rules.error.counterpartyRequired': 'Pilih rekanan Syrve.',
    'matching.rules.error.saveFailed': 'Gagal menyimpan aturan.',
    'matching.rules.error.deactivateFailed': 'Gagal menonaktifkan aturan.',
    'matching.rules.error.activateFailed': 'Gagal mengaktifkan aturan.',
    'matching.signal.rule': 'Aturan',
    'matching.signal.normalizedRule': 'Aturan ternormalisasi',
    'matching.signal.normalizedBankName': 'Nama bank ternormalisasi',
    'matching.signal.priority': 'Prioritas',
    'matching.signal.exactMatch': 'Kecocokan tepat',
    'matching.signal.normalizedMatch': 'Kecocokan setelah normalisasi',
    'matching.signal.containsMatch': 'Kecocokan sebagian',
    'matching.signal.manualSelection': 'Pilihan operator',
    'matching.status.unmatched': 'tidak cocok',
    'matching.status.lowConfidence': 'periksa',
    'matching.status.autoMatched': 'otomatis',
    'matching.status.manualMatched': 'manual',
    'matching.status.excluded': 'dikecualikan',
    'matching.matchType.rule': 'Aturan',
    'matching.matchType.normalized': 'Normalisasi',
    'matching.matchType.candidate': 'Kandidat',
    'matching.matchType.manual': 'Manual',
    'matching.matchType.unmatched': 'Tidak cocok',
    'matching.matchType.excluded': 'Dikecualikan',
    'matching.signal.excludeCategory': 'Alasan pengecualian',
    'matching.signal.excludeComment': 'Komentar',
    'matching.wizard.title': 'Wizard pencocokan counterparty',
    'matching.wizard.title.complete': 'Pencocokan selesai',
    'matching.wizard.step.transaction': 'Transaksi',
    'matching.wizard.step.counterparty': 'Counterparty',
    'matching.wizard.step.rule': 'Aturan',
    'matching.wizard.step.done': 'Selesai',
    'matching.wizard.review.nextSteps.title': 'Langkah selanjutnya',
    'matching.wizard.review.nextSteps.1': 'Periksa detail transaksi bank.',
    'matching.wizard.review.nextSteps.2': 'Klik “Pilih counterparty Syrve” dan pilih pemasok dari katalog.',
    'matching.wizard.review.nextSteps.3': 'Opsional: buat aturan agar pembayaran serupa dicocokkan otomatis.',
    'matching.wizard.review.transactionTitle': 'Transaksi bank',
    'matching.wizard.review.counterpartyFromBank': 'Counterparty dari bank',
    'matching.wizard.review.currentStatus': 'Status saat ini',
    'matching.wizard.review.selectCounterparty': 'Pilih counterparty Syrve',
    'matching.wizard.select.title': 'Pilih counterparty Syrve',
    'matching.wizard.select.counterpartyLabel': 'Counterparty Syrve',
    'matching.wizard.select.kindLabel': 'Tipe counterparty',
    'matching.wizard.select.kindPlaceholder': 'Pilih tipe',
    'matching.wizard.select.pickKindFirst': 'Pilih tipe terlebih dahulu — daftar hanya menampilkan counterparty aktif untuk tipe itu.',
    'matching.wizard.select.noActiveForKind': 'Tidak ada counterparty aktif (tidak dihapus) untuk tipe ini.',
    'matching.wizard.select.placeholder': 'Nama, ID, atau NPWP',
    'matching.wizard.select.emptySearch': 'Counterparty tidak ditemukan. Ubah pencarian.',
    'matching.wizard.select.loading': 'Memuat counterparty Syrve…',
    'matching.wizard.select.error': 'Gagal memuat counterparty Syrve',
    'matching.wizard.select.confirm': 'Konfirmasi pencocokan',
    'matching.wizard.select.sync.empty.title': 'Counterparty tidak ditemukan',
    'matching.wizard.select.sync.empty.description': 'Katalog counterparty kosong. Sinkronkan pemasok dari Syrve dan coba lagi.',
    'matching.wizard.select.sync.button': 'Sinkronkan counterparty',
    'matching.wizard.select.sync.connectionsLink': 'Koneksi Syrve',
    'matching.wizard.select.sync.noConnection': 'Konfigurasikan koneksi Syrve terlebih dahulu.',
    'matching.wizard.select.sync.error': 'Gagal menyinkronkan counterparty Syrve.',
    'matching.wizard.select.matchError': 'Gagal menyimpan pencocokan manual',
    'matching.wizard.rule.title': 'Aturan untuk impor berikutnya',
    'matching.wizard.rule.saved': 'Pencocokan manual disimpan.',
    'matching.wizard.rule.hint': 'Masukkan teks untuk menemukan counterparty ini pada impor berikutnya. Anda dapat memendekkannya menjadi fragmen nama yang stabil.',
    'matching.wizard.rule.bankName': 'Pola pencocokan otomatis',
    'matching.wizard.rule.normalizedName': 'Nama ternormalisasi',
    'matching.wizard.rule.priority': 'Prioritas',
    'matching.wizard.rule.priorityPlaceholder': 'Ditentukan otomatis oleh backend',
    'matching.wizard.rule.emptyPattern': 'Pola ternormalisasi kosong — tidak bisa membuat aturan. Selesai tanpa aturan.',
    'matching.wizard.rule.skip': 'Selesai tanpa aturan',
    'matching.wizard.rule.create': 'Buat aturan',
    'matching.wizard.rule.conflicts.title': 'Pratinjau konflik',
    'matching.wizard.rule.conflicts.hint': 'Prioritas efektif: {priority}. Periksa peringatan sebelum menyimpan.',
    'matching.wizard.rule.conflicts.loading': 'Memeriksa konflik aturan…',
    'matching.wizard.rule.conflicts.error': 'Gagal memeriksa konflik aturan',
    'matching.wizard.rule.createError': 'Gagal membuat aturan pencocokan',
    'matching.wizard.conflict.exactDuplicate': 'Duplikat tepat',
    'matching.wizard.conflict.duplicateScope': 'Konflik pemetaan',
    'matching.wizard.conflict.overlapping': 'Pola tumpang tindih',
    'matching.wizard.conflict.priorityShadowing': 'Prioritas',
    'matching.wizard.conflict.differentMapping': 'Counterparty Syrve berbeda',
    'matching.wizard.conflict.default': 'Konflik',
    'matching.wizard.conflict.ruleLine': 'Aturan: {pattern} → {counterparty} (prioritas {priority})',
    'matching.wizard.complete.done': 'Selesai',
    'matching.wizard.complete.skipped': 'Aturan tidak dibuat.',
    'matching.wizard.complete.manualSaved': 'Pencocokan manual disimpan.',
    'matching.wizard.complete.withRule': 'Pencocokan manual disimpan. {message}',
    'matching.wizard.complete.skippedFull': 'Pencocokan manual disimpan. Aturan tidak dibuat.',
    'matching.wizard.rule.created': 'Aturan dibuat. Impor berikutnya akan dicocokkan otomatis.',
    'matching.wizard.rule.createdReapplied': 'Aturan dibuat. Pencocokan diperbarui: {count}.',
    'matching.wizard.rule.alreadyExists': 'Aturan ini sudah ada. Aturan duplikat tidak dibuat.',
    'matching.wizard.rule.alreadyExistsReapplied': 'Aturan ini sudah ada. Pencocokan diperbarui: {count}.',
    'matching.wizard.sync.success': 'Sinkronisasi selesai: ditemukan {seen}, ditambahkan {inserted}, diperbarui {updated}.',
  },
} as const;
